<template>
    <div>
        <div class="gap-7 md:grid md:grid-cols-2" :class="[((items.length === 2 || items.length === 5) && !editMode) ? 'lg:grid-cols-12' : 'lg:grid-cols-3']">
            <slot />
        </div>
        <div v-if="items.length > 4 && limitItems" class="py-4 mt-6 text-center border-b border-black">
            <button class="inline-flex justify-center items-center text-2xl" @click="moreOrLess">
                <icon :class="[isLimited ? 'rotate-90' : '-rotate-90']" class="mr-3 w-3 h-5 transform" name="chevron" />
                <span class="font-bold font-heading">{{ isLimited ? loadMoreLabel : showLessLabel }}</span>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Provide } from 'vue-property-decorator';
import StoryItem from './StoryItem.vue';
import Icon from '../base/Icon.vue';

@Component({
    components: { Icon }
})
export default class StoriesOverview extends Vue {
    @Provide('registerStory') childRegistration = this.registerItem;

    @Prop({ required: true }) loadMoreLabel: string;
    @Prop({ required: true }) showLessLabel: string;
    @Prop({ default: true }) limitItems: boolean;
    @Prop({ default: false }) editMode: boolean;

    items: StoryItem[] = [];
    limit = Infinity;

    get isLimited() {
        return this.limit < this.items.length && this.items.length > 4;
    }

    registerItem(story: StoryItem) {
        this.items.push(story);
        if (this.$children.filter(this.filterItems).length === this.items.length) {
            this.limit = this.limitItems ? 4 : this.items.length;
            this.applyLimit();
        }
    }

    // check children to only count story components
    filterItems(child: Vue) {
        return child.$vnode && child.$vnode.componentOptions && child.$vnode.componentOptions.tag === 'story-item';
    }

    applyLimit() {
        this.items.forEach((item: StoryItem, index) => {
            item.show = index < this.limit;
        });
    }

    moreOrLess() {
        if (this.limit < this.items.length) {
            this.limit = Math.min(this.limit + 6, this.items.length);
        } else {
            this.limit = 4;
        }
        this.applyLimit();
    }
}
</script>
